import './ContentPriorityPlaceholder.sass';

import React, { FC, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ContentPriorityType } from '$store/main/interface';
import { ContentPriorityPlaceholderProps } from './ContentPriorityPlaceholder.interface';
import { List, ListItem, Placeholder } from '$uikit';
import { useTranslator } from '$hooks';
import { profileActions } from '$store/profile';
import { mainSelector } from '$store/main';
import { SubscriptionIcon } from '$shared/components';
import { SubscriptionType } from '$store/models';
import { goTo } from '$navigation/helper';
import { SUBSCRIPTION_MEDIA } from '$shared/constants/pages';

export const ContentPriorityPlaceholder: FC<ContentPriorityPlaceholderProps> = ({
  centered,
}) => {
  const t = useTranslator();
  const dispatch = useDispatch();
  const { adultPrice, otherPrice } = useSelector(mainSelector);
  //const { route } = useRoute();
  //const activeTab = route.params?.section ?? 'following';

  const handleChangeContentPriority = useCallback(
    (contentPriority: ContentPriorityType) => {
      dispatch(
        profileActions.changeContentPriority({
          contentPriority,
          //section: activeTab,
          needReload: true,
          isStartScreen: true,
        }),
      );

      if (contentPriority === ContentPriorityType.OTHER) {
        goTo(SUBSCRIPTION_MEDIA);
      }
    },
    [dispatch],
  );

  return (
    <Placeholder
      className="ContentPriorityPlaceholder"
      centered={centered}
      title={t('feed_priority_change_title')}
      actions={
        <List>
          <ListItem
            before={
              <SubscriptionIcon
                type={SubscriptionType.Media}
                authorId={0}
                size="list-icon"
              />
            }
            chevron
            onClick={() => handleChangeContentPriority(ContentPriorityType.OTHER)}
          >
            {t('feed_priority_change_button_other')}
          </ListItem>
          <ListItem
            before={
              <SubscriptionIcon
                type={SubscriptionType.Adult}
                authorId={0}
                size="list-icon"
              />
            }
            chevron
            onClick={() => handleChangeContentPriority(ContentPriorityType.ADULT)}
          >
            {t('feed_priority_change_button_adult')} (18+)
          </ListItem>
        </List>
      }
      note={t('feed_priority_change_note')}
    >
      {t('feed_priority_change_description')}
    </Placeholder>
  );
};
